var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { perkbox } from "@irati/ui/src/global/colors";
import { StyledNav, StyledNavItem } from "./styled";
var Headers = /** @class */ (function (_super) {
    __extends(Headers, _super);
    function Headers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Headers.prototype.render = function () {
        var _a = this.props, tabs = _a.tabs, fullWidth = _a.fullWidth, activeColor = _a.activeColor;
        return (React.createElement(StyledNav, { bsStyle: "pills" }, tabs.map(function (_a) {
            var key = _a.key, title = _a.title;
            return (React.createElement(StyledNavItem, { fullWidth: fullWidth, activeColor: activeColor, key: key, eventKey: key }, title));
        })));
    };
    Headers.defaultProps = {
        fullWidth: false,
        activeColor: perkbox.blue
    };
    return Headers;
}(Component));
export default Headers;
